import { createIcon } from './icon-utils';

export const BackArrowIcon = createIcon({
  path: 'M5.373 12.75l6.595 6.595c.293.293.293.767 0 1.06-.293.293-.768.293-1.06 0L3.031 12.53c-.293-.293-.293-.767 0-1.06l7.875-7.875c.293-.293.768-.293 1.06 0 .294.293.294.767 0 1.06L5.374 11.25h15.064c.415 0 .75.336.75.75s-.335.75-.75.75H5.373z',
});
